module.exports = __webpack_public_path__ + "src/assets/img/4_1art_1part_gallery.93efb959.jpg";